/* ============
 * State of the panoramas module
 * ============
 *
 * The initial state of the panoramas module.
 */

export default {
  panoramas: [],
};
